import { render, staticRenderFns } from "./CurrentlyViewedResourceMetadata.vue?vue&type=template&id=345f0236&scoped=true"
import script from "./CurrentlyViewedResourceMetadata.vue?vue&type=script&lang=js"
export * from "./CurrentlyViewedResourceMetadata.vue?vue&type=script&lang=js"
import style0 from "./CurrentlyViewedResourceMetadata.vue?vue&type=style&index=0&id=345f0236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f0236",
  null
  
)

export default component.exports